import React from 'react';
import dayjs from 'dayjs-ext';
import { UiDatePicker } from '../ui-kit/UiDatePicker';

/**
 * Ensures the value is a Date object, not a string.
 * date-fns v2+ requires Date objects, not strings.
 */
function ensureDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    // ISO date strings like "2025-01-15" or "2025-01-15T00:00:00Z";
    // the picker throws on an Invalid Date
    const date = dayjs(value).toDate();
    return Number.isNaN(date.getTime()) ? null : date;
  }
  return null;
}

/* eslint-disable react/prop-types */
export function UiDatePickerAdapter({ input, meta, ...rest }) {
  const selected = ensureDate(input.value);
  // the picker shows a string value as typed text, not as the selected date
  const value =
    input.value && typeof input.value === 'string' ? selected : input.value;
  return (
    <UiDatePicker
      {...input}
      {...rest}
      value={value}
      selected={selected}
      errorMessage={meta.touched ? meta.error || meta.submitError || '' : ''}
    />
  );
}
